import { useCallback } from 'react';
import { IPageLink } from '@vivli/shared/infrastructure/interface';

export const useTopTabNav = (links: IPageLink[]) => {
    const normalizePath = useCallback((path: string) => path.toLowerCase().replace(/\/+$/, ''), []);

    const findMatchingTopTab = useCallback(
        (pathname: string) => {
            const normalizedPath = normalizePath(pathname);

            return links.find((link) => {
                if (!link?.url) {
                    return false;
                }

                const tabPath = `/admin/${link.url.toLowerCase()}`;
                return normalizedPath === tabPath || normalizedPath.startsWith(`${tabPath}/`);
            });
        },
        [links, normalizePath]
    );

    const findAssociatedTopTab = useCallback(
        (pathname: string) => {
            const assocPath = normalizePath(pathname);

            //set up associations based on the router in use-default-routes.hook.ts
            //this will be made more configurable in an upcoming PR.
            if (assocPath.includes('datarequestdetails') || assocPath.includes('admindatarequests')) {
                return links.find((link) => link.url === 'requests');
            }
            if (assocPath.includes('enquiry')) {
                return links.find((link) => link.url === 'enquiries');
            }
            if (assocPath.includes('submission')) {
                return links.find((link) => link.url === 'study-submissions');
            }
        },
        [links, normalizePath]
    );

    return {
        normalizePath,
        findMatchingTopTab,
        findAssociatedTopTab
    };
};
